module.exports = __webpack_public_path__ + "img/icone_hdro_parado_vermelho.c3bb93cf.png";